import { unwrap, withSignal } from "@nexxt/api-client";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { m } from "../../../paraglide/messages.js";
import { api } from "../../api";

// The brands of crm (ADR-295): one read for the pickers and for the names the lists show for an id. They change
// rarely, so they stay fresh for a while.

const brands = api.crm.brands;

export const brandQueries = {
  list: () =>
    queryOptions({
      queryKey: ["crm-brands"],
      queryFn: ({ signal }) => unwrap(brands.$get({ query: {} }, withSignal(signal))),
      staleTime: 10 * 60_000,
    }),
};

/** The name of the brand of a template or a kit; `null` is Tomorrow, an id not (yet) known its placeholder. */
export function useBrandName(): (brandOrgId: string | null) => string {
  const { data } = useQuery(brandQueries.list());
  const names = new Map(data?.items.map((b) => [b.id, b.name]));
  return (brandOrgId) => (brandOrgId === null ? m.brand_tomorrow() : (names.get(brandOrgId) ?? m.brand_unknown()));
}
